import { render, staticRenderFns } from "./PrivateCrmAdModal.vue?vue&type=template&id=6d9711f6&scoped=true&"
import script from "./PrivateCrmAdModal.vue?vue&type=script&lang=js&"
export * from "./PrivateCrmAdModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivateCrmAdModal.vue?vue&type=style&index=0&id=6d9711f6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9711f6",
  null
  
)

export default component.exports